import { ActionStatus, Tracker } from '../types';
import IconActionStatus from './IconActionStatus';

type TrackerResumeLineProps = {
    tracker: Tracker;
    status: ActionStatus;
    fleetStatus?: ActionStatus;
}

export default function TrackerResumeLine({tracker, status, fleetStatus}: TrackerResumeLineProps) {
    return (
        <tr>
            <td className="tracker-name">{tracker.name}</td>
            <td className="tracker-hardware_id">{tracker.hardware_id}</td>
            <td className="tracker-url">{tracker.server_url}</td>
            <td className="tracker-port">{tracker.server_port}</td>
            <td className="tracker-status"><IconActionStatus status={status} /></td>
            <td className="tracker-status">{fleetStatus !== undefined && <IconActionStatus status={fleetStatus} />}</td>
        </tr>
    )
}

